
function hideConsumerUserProductIdElements() {
  document.querySelectorAll("dd").forEach(dd => {
      if (dd.textContent.includes("consumerUserProductId")) {
          dd.style.display = "none";
      }
  });
  document.querySelectorAll('.account-dashboard__table-info').forEach (
    info => {
    if(info.textContent.includes("consumerUserProductId")) {
    info.style.display="none";
    }
    }
  )
}


function openMiniCart() {
  const cartDrawers = document.querySelectorAll('cart-drawer');
  if (cartDrawers.length > 0) {
    cartDrawers[0].classList.add('is-visible');
  }
  hideConsumerUserProductIdElements();

}

function closeMiniCart() {
  const cartDrawers = document.querySelectorAll('cart-drawer');
  if (cartDrawers.length > 0) {
    cartDrawers[0].classList.remove('is-visible');
  }
}
  
function refreshCartDrawer() {
  const rootAttribute = document.querySelector('[data-root]').getAttribute('data-root');

  let fetchUrl = '/collections/all?section_id=cart-drawer';
  if (rootAttribute && rootAttribute !== '/') {
    fetchUrl = `${rootAttribute}${fetchUrl}`;
  }

  fetch(fetchUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const updatedCartContent = doc.querySelector('.cart-drawer__body');

      const cartDrawer = document.querySelector('.cart-drawer__body');
      if (cartDrawer && updatedCartContent) {
        cartDrawer.innerHTML = updatedCartContent.innerHTML;
      }
      updateCartImages();
      hideDuplicateSecondItems();
      groupCartItemsByDataGroup();
      secondItemPromo();
      rebindRemoveButtons();
      updateCartCounters();
      initializeEventListeners();
      hideConsumerUserProductIdElements();
    })
    .catch(error => {
      console.error('Errore durante l\'aggiornamento del carrello:', error);
    });
    hideConsumerUserProductIdElements();
}

function updateCartPage() {
  if (window.location.pathname.includes('/cart')) {
    location.reload();
  }
  hideConsumerUserProductIdElements();
}

function updateCartImages() {
  let customizeImage = Cookies.get('customizeImage');
  if (!customizeImage) return;

  customizeImage = JSON.parse(customizeImage);

  document.querySelectorAll('.cart-item').forEach(cartItem => {
    const variantId = cartItem.getAttribute('data-variant-id');
    const consumerUserId = cartItem.getAttribute('data-consumer');

    const matchedItem = customizeImage.find(item =>
      item.variantId === variantId && String(item.consumerProductId) === consumerUserId
    );

    if (matchedItem) {
      const cartImage = cartItem.querySelector('.cart-item__media-img');
      const mediaContainer = cartItem.querySelector('.media');
      
      if (cartImage && mediaContainer && matchedItem.updatedImagePathPreview) {
        let imageArray = matchedItem.updatedImagePathPreview;

        if (typeof imageArray === 'string') {
            imageArray = JSON.parse(imageArray);
        }

        if (Array.isArray(imageArray) && imageArray.length > 0) {
          cartImage.src = imageArray[0];

          if (imageArray.length > 1) {
            cartImage.classList.add('cart-item__media-img-1');
          }

          imageArray.slice(1).forEach(imgSrc => {
            const newImg = document.createElement('img');
            newImg.src = imgSrc;
            newImg.classList.add('cart-item__media-img-2');
            mediaContainer.appendChild(newImg);
          });
        }
      }
    }
  });
}

async function addToCart(shopifyExternalId, consumerUserProductId, additionalProperties = {}, quantity = 1) {
  const productData = {
      id: shopifyExternalId,
      quantity: quantity,
      properties: {
          consumerUserProductId: consumerUserProductId,
          ...additionalProperties
      }
  };

  try {
      const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(productData),
      });

      if (response.ok) {
          const cartData = await response.json();
          updateCartCounters();
          refreshCartDrawer();
          openMiniCart();
          return { success: true, data: cartData };
      } else {
          const errorResponse = await response.json();
          console.error("Errore nell'aggiunta al carrello:", errorResponse);
      }
  } catch (error) {
      console.error(`Errore di rete durante l'aggiunta al carrello: ${error}`);
  }
}


function hideDuplicateSecondItems() {
  const groupCounts = {};
  document.querySelectorAll('.cart-item').forEach(item => {
      const group = item.getAttribute('data-group');
      if (group) {
          groupCounts[group] = (groupCounts[group] || 0) + 1;
      }
  });

  document.querySelectorAll('.cart-item').forEach(item => {
      const group = item.getAttribute('data-group');
      const secondItem = item.querySelector('.cart-item__second-item');

      if (secondItem && groupCounts[group] > 1) {
          secondItem.classList.add('hidden');
      }
  });
}

function groupCartItemsByDataGroup() {
  const groups = {};
  const cartItems = document.querySelectorAll('.cart-item');

  cartItems.forEach(item => {
      const group = item.getAttribute('data-group');

      if (!group) return;

      if (!groups[group]) {
          groups[group] = [];
      }

      groups[group].push(item);
  });

  Object.keys(groups).forEach(group => {
      const items = groups[group];

      if (items.length > 1) {
          const wrapper = document.createElement('div');
          wrapper.classList.add('cart-item', 'double');

          items[0].parentNode.insertBefore(wrapper, items[0]);

          items.reverse().forEach(item => wrapper.appendChild(item));
      }
  });
}

function secondItemPromo() {
  const baseUrl = document.querySelector("html")?.getAttribute("data-base-url");
  const countryId = document.querySelector("html")?.getAttribute("data-country-id");
  
  document.querySelectorAll('.cart-item__second-item').forEach(item => {
      item.addEventListener('click', async () => {
          const variantId = item.getAttribute('data-variant-id');
          const sku = item.getAttribute('data-sku');
          const dataGroup = item.getAttribute('data-group');
          const currency = item.getAttribute('data-currency');
          const language = item.getAttribute('data-language');
          const parentProductId = item.getAttribute('data-parent-consumer-product-id');
          const spinner = item.querySelector('.loading__spinner');
          const plus = item.querySelector('.close');

          spinner.classList.remove('hidden');
          plus.classList.add('hidden');

          const secondItemPayload = {
            relatedSku: sku,
            parentConsumerUserProductId: parentProductId
          };

          const secondItemApiUrl = `${baseUrl}/a/ext/api/v1/consumer/products/related/FromShopify`;
          console.log(secondItemApiUrl);

          const secondItemHeaders = new Headers();
          secondItemHeaders.append("x-user-country-id", countryId);
          secondItemHeaders.append("x-user-currency", currency);
          secondItemHeaders.append("x-user-customer-id", "3");
          secondItemHeaders.append("x-user-language", language);
          secondItemHeaders.append("Content-Type", "application/json");
      
          const secondItemRequestOptions = {
            method: "POST",
            headers: secondItemHeaders,
            body: JSON.stringify(secondItemPayload),
            redirect: "follow"
          };

          try {
            const secondItemResponse = await fetch(secondItemApiUrl, secondItemRequestOptions);
            const secondItemData = await secondItemResponse.json();
      
            if (secondItemResponse.ok) {
              if (!variantId || !sku) {
                console.error("Dati mancanti: variantId o sku non trovati.");
                return;
              }
              
              const secondItemProductId = secondItemData.id

              try {
                  await addToCart(variantId, secondItemProductId, {
                      _second_pant: true,
                      _data_group: dataGroup
                  });
    
                  refreshCartDrawer();
                  updateCartPage();
              } catch (error) {
                  console.error("Errore nell'aggiunta al carrello:", error);
              }
            } else {
              console.error(`Errore: ${JSON.stringify(secondItemData)}`);
            }
          } catch (secondItemError) {
            console.error(`Errore di rete: ${secondItemError}`);
          } finally {
            spinner.classList.add('hidden');
            plus.classList.remove('hidden');
          }
      });
  });
}

async function removeFromCart(itemKey) {
  try {
      const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              id: itemKey,
              quantity: 0
          })
      });

      if (!response.ok) {
          throw new Error("Errore nella rimozione dell'elemento dal carrello");
      }

      const cart = await response.json();
      refreshCartDrawer();
      return cart;
  } catch (error) {
      console.error("Errore:", error);
  }
}

async function removeMultipleFromCart(itemKeys) {
  try {
      const updates = {};
      itemKeys.forEach(key => {
          updates[key] = 0;
      });

      const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
      });

      if (!response.ok) {
          throw new Error("Errore nella rimozione degli elementi dal carrello");
      }

      const cart = await response.json();
      refreshCartDrawer();
      updateCartPage();
      return cart;
  } catch (error) {
      console.error("Errore:", error);
  }
}

function rebindRemoveButtons() {
  document.querySelectorAll(".cart-item").forEach(cartItem => {
      cartItem.querySelectorAll("cart-remove-button").forEach(button => {
          button.removeEventListener("click", removeItemEventListener);
          button.addEventListener("click", removeItemEventListener);
      });

      cartItem.querySelectorAll("cart-remove-button-global").forEach(globalButton => {
          globalButton.removeEventListener("click", removeGroupEventListener);
          globalButton.addEventListener("click", removeGroupEventListener);
      });
  });
}

async function removeItemEventListener(event) {
    const cartItem = event.target.closest(".cart-item");
    const itemKey = cartItem.getAttribute("data-key");
    if (itemKey) {
      await removeFromCart(itemKey); 
      updateCartPage();
    }
}

function removeGroupEventListener(event) {
    const cartItem = event.target.closest(".cart-item");
    const group = cartItem.getAttribute("data-group");
    if (group) {
        const matchingItems = document.querySelectorAll(`.cart-item[data-group='${group}']`);
        const keys = Array.from(matchingItems).map(item => item.getAttribute("data-key"));
        removeMultipleFromCart(keys);
    }
}

updateCartImages();
hideDuplicateSecondItems();
groupCartItemsByDataGroup();
secondItemPromo();
rebindRemoveButtons();

hideConsumerUserProductIdElements();
